import { Component } from 'preact';
import { DropdownItem } from 'reactstrap';

/**
 * @property {*}      value
 * @property {string} label
 */
export default class CustomDropDownOption extends Component {

	onClick = () => {
		const props = this.props;
		props.onChange(props.value);
	};

	/**
	 * @param {KeyboardEvent} event
	 */
	onKeyDown = (event) => {
		if (event.keyCode === 13 || event.key === 'Enter') {
			const props = this.props;
			props.onChange(props.value);
		}
	};

	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	render({ label }) {
		return (
			<DropdownItem onClick={this.onClick} onKeyDown={this.onKeyDown}>
				{label}
			</DropdownItem>
		);
	}
}



// WEBPACK FOOTER //
// ./components/form/dropdown/CustomDropDownOption.js